import { connect } from 'react-redux';

import { getSelectOptions } from 'src/reducers/selectOptions';
import EmployeeLeaveOfAbsenceItemShow from '../components/EmployeeLeaveOfAbsenceItemShow';

export default connect(state => ({
  leaveOfAbsenceReasonTypes: getSelectOptions(state, 'leaveOfAbsenceReasonTypes')
}))(EmployeeLeaveOfAbsenceItemShow);
